module.exports = __webpack_public_path__ + "static/media/facebook.c39fdcd8.svg";